import cookie from 'cookie';
/* eslint-disable no-param-reassign */
import { type Event } from '@sentry/react';
import { bpeConfig } from '@enterprise/common';

export const shouldIgnoreError = (event: Event, ignoreNonUsers: boolean): boolean => {
  const tenantId = bpeConfig.tenant.id || '';

  const ignoredErrors = [
    tenantId.includes('dev'),
    // This error is expected whenever a user tries to edit a Workday Organization in the Org Chart
    (event?.extra?.error as any)?.message === 'Cannot update a Workday organization',
    // This error is expected whenever a user tries to edit a Workday Organization in the Org Chart
    (event?.extra?.error as any)?.[0]?.message.includes('Cannot update a Workday organization'),
    // This error is expected when the user
    (event?.extra?.error as any)?.[0]?.message.includes('Received status code 401'),
    includes401Exception(event),
    // API calls handled already. No duplicates
    event?.message?.startsWith('API call failed'),
    // Ignore event if user is not logged in
    ignoreNonUsers ? event?.user?.id?.toString().toLowerCase()[0] !== 'p' : false,
    isSessionExpired(),
    isMovingBrokenEngagement(event)
  ];
  return ignoredErrors.some(Boolean);
};

// If user tries move broken engagement, BE will return an error
// Error is expected and handled by BE
function isMovingBrokenEngagement(event: Event): boolean {
  return event.tags?.errorCode === 'OC4001167' && event.tags.operationName === 'PATCH_ENGAGEMENT_ORG';
}

function isSessionExpired(): boolean {
  const timeoutCookie = cookie.parse(document.cookie).TTL;
  return !timeoutCookie && !localStorage.getItem('auth:logged-in');
}

function includes401Exception(event?: Event): boolean | undefined {
  return event?.exception?.values?.some((exception) =>
    exception.value?.includes('Response not successful: Received status code 401')
  );
}
